document.addEventListener('DOMContentLoaded', function() {
  if (!localStorage.getItem('confettiDone')) {
    const script = document.createElement('script');
    script.src = "https://cdn.jsdelivr.net/npm/canvas-confetti@1.5.1/dist/confetti.browser.min.js";
    script.onload = function() {
      confetti({
        particleCount: 200,
        spread: 90,
        colors: ['#FF0800', '#6390C3', '#FF8610', '#E6126F', '#FFD700'],
        origin: { y: 0.6 }
      });

      const message = document.createElement('div');
      message.textContent = "Bienvenue chez Terre 2 Mômes";
      message.style.position = "fixed";
      message.style.top = "20px";
      message.style.left = "50%";
      message.style.transform = "translateX(-50%)";
      message.style.background = "#FFFE91";
      message.style.color = "#000";
      message.style.padding = "10px 20px";
      message.style.borderRadius = "10px";
      message.style.fontWeight = "700";
      message.style.fontSize = "18px";
      message.style.zIndex = "9999";
      message.style.boxShadow = "0 4px 8px rgba(0,0,0,0.2)";
      document.body.appendChild(message);

      setTimeout(() => {
        message.remove();
      }, 4000);

      localStorage.setItem('confettiDone', 'true');
    };
    document.body.appendChild(script);
  }
});